import { AxiosResponse } from 'axios';
import { FormikHelpers } from 'formik';
import { useMutation, useQueryClient } from 'react-query';

// components
import { errorToast } from 'components/toasts/error';
import { successToast } from 'components/toasts/success';
// configs
import { API } from 'configs/api';
// keys
import { conversationsQueryKeys } from './conversationsQueryKeys';
// types
import { ISingleMessage } from './types';
import { getShortUrlFromUrl } from 'utils/url';
interface ISendConversationMessage {
  message: string;
  userId: string;
}

export const sendConversationMessageMutation = async (
  conversationId: string,
  data: { message: string }
) => {
  const shortUrl = getShortUrlFromUrl();
  if (!shortUrl) {
    throw new Error('Invalid url');
  }
  const response: AxiosResponse<ISingleMessage> = await API.post<
    ISingleMessage
  >(`/playback/${shortUrl}/conversations/${conversationId}/send`, data);

  return response.data;
};

export const useSendConversationMessage = () => {
  const queryClient = useQueryClient();
  return useMutation<
    ISingleMessage,
    Error,
    {
      conversationId: string;
      data: { message: string };
      formikHelpers: FormikHelpers<ISendConversationMessage>;
    }
  >(
    variables =>
      sendConversationMessageMutation(variables.conversationId, variables.data),
    {
      onSuccess: (_, variables) => {
        variables.formikHelpers.resetForm();
        successToast({ title: 'Your message is sent successfully!' });
        queryClient.invalidateQueries(conversationsQueryKeys.all());
      },
      onError: () => {
        errorToast({ title: 'Something went wrong' });
      },
    }
  );
};
